import angular, { ILogService, ITimeoutService } from 'angular'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IEdicionForm, IModelFormulario } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { Preguntas } from '../../../data/Preguntas'
import { BloqueForm } from '../../../data/bloque-form'
import { Formulario } from '../../../data/formulario'

import { chain } from 'lodash'
import './panel-formular.scss'

class SideBarCtrl {
  $visible = false

  toggle() {
    this.$visible = !this.$visible
  }

  open() {
    this.$visible = true
  }
}

class PanelFormularComponentCtrl {
  idform!: number | undefined

  list: Formulario[]

  panelpregs = {
    bloque: null as BloqueForm,
    panel: new SideBarCtrl(),
  }
  preguntas: Preguntas

  constructor(
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  private goform(idform: number) {
    setTimeout(() => {
      let _el = document.getElementById('form_a_' + idform)

      if (_el) _el.scrollIntoView()
      else this.goform(idform)
    }, 100)
  }

  $onInit(): void {
    this.$log.info('[PanelFormularComponentCtrl] onInit')

    if (this.idform) this.goform(this.idform)

    this.AccesoDatos.EdicionFormular_CLIENT.listaFormularios().then((response) => {
      this.list = chain(response.list)
        .map((f) => new Formulario(f))
        .value()

      this.preguntas = new Preguntas(response.preguntas)
    })
  }

  nuevoFormulario() {
    let _nuevo = {} as IEdicionForm
    _nuevo.data = {} as IModelFormulario

    this.AccesoDatos.EdicionFormular_CLIENT.nuevoFormulario(_nuevo).then((response) => {
      this.list.push(new Formulario(response, true))

      _scrollBottom()
    })
  }

  abrirPanelPreguntas(form: Formulario, bloque: BloqueForm) {
    this.$log.info('Nueva pregunta para form ', form, bloque)

    this.panelpregs.bloque = bloque
    this.panelpregs.panel.open()
  }

  nuevoFormDuplicado(form: IEdicionForm) {
    this.list.push(new Formulario(form, true))

    _scrollBottom()
  }
}

angular.module('candidato').component('panelFormular', {
  bindings: {
    idform: '<',
  },
  controller: PanelFormularComponentCtrl,
  template: require('./panel-formular.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/panel-formular/panel-formular.component.html"
})

function _scrollBottom() {
  // scroll bottom
  var a = $('.container-fluid')

  if (a && a.length) {
    var _el = a[0]

    setTimeout(() => _el.scroll({ behavior: 'smooth', top: _el.scrollHeight + 10000 }), 30)
  }
}
